
import {
	Official
} from "./official.js"










import {
	isWeChat
} from '@/utils/util.js'
export class Base {
	constructor() {
		this.share = null
		// this.acceptPrams = ['title', 'desc', 'link', 'img', 'defaultUrl']
	}

	init() {
		// 根据平台去生成对应类

		if (isWeChat()) {
			this.share = new Official()
		}







	}
	/**
	 * @param {Object} data
	 * @param {string}  data.share_title
	 * @param {string}  data.share_desc 
	 * @param {string}  data.share_url // 例 /pages/index/index?id=12
	 * @param {string}  data.share_pic
	 */
	initShareUrl(data) {
		if (this.checkPlatform()) return false
		const params = this.share.init(data)
		console.log("params",params)
		console.log(params, 'share-----params')



	}
	
	check(data) {
		for (let key in data) {
			if (this.acceptPrams.indexOf(key) === -1) {
				throw new Error('你丫，传错了')
			}
		}
	}

	checkPlatform() {
		return !this.share
	}
}

const share = new Base()
share.init()
export default share
